import Label from "components/Label/Label";
import React, { FC,useEffect, useState } from "react";
import Avatar from "shared/Avatar/Avatar";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";
import Textarea from "shared/Textarea/Textarea";
import CommonLayout from "./CommonLayout";
import { Helmet } from "react-helmet";
import {  useHistory } from 'react-router-dom'
import supabase from "utils/supabaseClient"
import converSelectedDateToString from "utils/converSelectedDateToString";
import useAuth from "components/Authprovider/Auth";

export interface AccountPageProps {
  className?: string;
}


type accountData = {
  name: string,
  gender: string,
  username: string,
  email: string,
  phone: string,
  dob: string,
  address: string,
  about: string,
  avatar: string
}

const initial_data: accountData ={
  name: "",
  gender: "",
  username: "",
  email: "",
  phone: "",
  dob: "",
  address: "",
  about: "",
  avatar: ""
}

const AccountPage: FC<AccountPageProps> = ({ className = "" }) => {
  
 const {user} = useAuth()

  return (
    <div className={`nc-AccountPage ${className}`} data-nc-id="AccountPage">
      <Helmet>
        <title>Account || Nilebooking</title>
      </Helmet>
      <CommonLayout>
        <div className="space-y-6 sm:space-y-8">
          {/* HEADING */}
          <h2 className="text-3xl font-semibold">Account infomation</h2>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="flex flex-col md:flex-row">
            <div className="flex-grow mt-10 md:mt-0 md:pl-16 max-w-3xl space-y-6">
              <div>
                <Label>Name</Label>
                <Input className="mt-1.5" defaultValue="Eden Tuan" value={user?.name} onChange={e => console.log(e) }/>
              </div>
              {/* ---- */}
              <div>
                <Label>Gender</Label>
                <Select className="mt-1.5"  value={user?.gender} onChange={e => console.log(e) }>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </Select>
              </div>
              {/* ---- */}
    
              {/* ---- */}
              <div>
                <Label>Email</Label>
                <Input className="mt-1.5" defaultValue="example@email.com" value={user?.email} onChange={e => console.log(e) }/>
              </div>
              {/* ---- */}
    
              {/* ---- */}
             
              {/* ---- */}
              <div>
                <Label>Phone number</Label>
                <Input className="mt-1.5" defaultValue="003 888 232" value={user?.phone_number} onChange={e => console.log(e) }/>
              </div>
              {/* ---- */}
             
              <div className="pt-2">
                {/*<ButtonPrimary >Update info</ButtonPrimary>*/}
              </div>
            </div>
          </div>
        </div>
      </CommonLayout>
    </div>
  );
};

export default AccountPage;
